<template>
  <div class="aboutUs">
    <div class="boxCenter">
      <div class="insideBanner">
        <img :src="aboutBanner" alt="TINDOE坦途"/>
        <!--<div class="title">活动专区</div>-->
      </div>
      <div class="aboutInfo">
        <div class="title"><span class="name">相册留影</span> album<span class="brick"></span></div>
        <div class="introduce" v-html="intro">
        </div>
        <!-- <div class="imgBox">
          <img :src="introImg" alt="TINDOE坦途"/>
        </div> -->
      </div>
      <!-- <div class="contactBox">
        <div class="imgBox"><img :src="mapAddress" alt="TINDOE坦途"/></div>
        <div class="contactItem">
          <div class="title"><span class="name">联系我们</span> CONTACT US<span class="brick"></span></div>
          <div class="item item1">{{telephone}}</div>
          <div class="item item2">{{mobilePhone}}</div>
          <div class="item item3">{{mail}}</div>
          <div class="item item4">{{address}}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        dataObj:null,
        intro:'',
        aboutBanner:''
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        this.$https.get('/api/config').then((response)=>{
          this.dataObj = response.data
          for(let i=0;i<response.data.length;i++){
            let item = response.data[i]
            if(item.id == 12){
              this.intro =  item.msg
              continue
            }
            if(item.id == 13){
              this.aboutBanner =  item.msg
              continue
            }
          }
        }).catch((error) => {

        });
      }
    }
  }
</script>

<style scoped>
  .aboutUs{
    background:#fafafa;
  }
  .insideBanner{
    width: 1200px;
    height: 275px;
    position: relative;
  }
  .insideBanner .title{
    font-size: 48px;
    color: #ffffff;
    width: 100%;
    text-align: center;
    left: 0px;
    top: 80px;
    position: absolute;
  }
  .aboutInfo{
    padding-top: 52px;
    overflow: hidden;
    min-height: 400px;
  }
  .aboutInfo .title{
    height: 43px;
    line-height: 43px;
    font-size: 30px;
    color: #999999;
    position: relative;
    text-transform:uppercase;
  }
  .aboutInfo .title .name{
    color: #3987e7;
  }
  .aboutInfo .title .brick{
    position: absolute;
    left: 0px;
    bottom: -8px;
    display: block;
    width: 57px;
    height: 8px;
    background: #3987e7;
  }
  .aboutInfo .introduce{
    width: 100%;
    margin: 30px 0;
    float: left;
  }
  .aboutInfo .introduce p{
    font-size: 14px;
    color: #666666;
    line-height: 28px;
  }
  .aboutInfo .imgBox{
    float: left;
    margin-top: 30px;
    width: 600px;
    margin-left: 40px;
  }
  .aboutInfo .imgBox img{
    width: 100%;
  }
  .contactBox{
    overflow: hidden;
    padding-top: 100px;
  }
  .contactBox .imgBox{
    width: 600px;
    height: 400px;
    float: left;
  }
  .contactBox .imgBox img{
    width: 100%;
    height: 100%;
  }
  .contactBox .contactItem{
    float: left;
    width: 530px;
    margin-left: 70px;
  }
  .contactItem .title{
    height: 43px;
    line-height: 43px;
    font-size: 30px;
    color: #999999;
    position: relative;
    text-transform:uppercase;
    margin-bottom:35px;
  }
  .contactItem .title .name{
    color: #3987e7;
  }
  .contactItem .title .brick{
    position: absolute;
    left: 0px;
    bottom: -8px;
    display: block;
    width: 57px;
    height: 8px;
    background: #3987e7;
  }
  .contactItem .item{
    height: 95px;
    padding-left: 60px;
    background-position: 10px 10px;
    background-repeat: no-repeat;
    font-size: 14px;
    line-height: 42px;
    color: #333333;
  }
  .contactItem .item.item1{background-image: url("../assets/images/telphone.png")}
  .contactItem .item.item2{background-image: url("../assets/images/phone.png")}
  .contactItem .item.item3{background-image: url("../assets/images/mail.png")}
  .contactItem .item.item4{background-image: url("../assets/images/location.png")}
</style>



// WEBPACK FOOTER //
// src/components/album.vue